import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=296d0dbf&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=296d0dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d0dbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296d0dbf')) {
      api.createRecord('296d0dbf', component.options)
    } else {
      api.reload('296d0dbf', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=296d0dbf&scoped=true&", function () {
      api.rerender('296d0dbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B2HbSvxlCXzR/JS/comp/SearchFilterTokens.vue"
export default component.exports